import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

interface RedirectWithSuffixProps {
    fromBase: string
    toBase: string
}

export function RedirectWithSuffix({ fromBase, toBase }: RedirectWithSuffixProps): React.JSX.Element {
    const location = useLocation()
    const pathname = location.pathname.startsWith(fromBase)
        ? location.pathname.slice(fromBase.length)
        : ''
    const search = location.search
    const targetPath = `${toBase}${pathname}${search}`
    return <Navigate to={targetPath} replace />
}

